
import { authHeader } from '../_helpers';
import { CONST } from '../_config';
// import CryptoJS from 'crypto-js';
// import env from "@beam-australia/react-env";
export const userService = {
    login,
    getProfile,
    logout,
    updateUserPassword,
    updateUserPasswordSubmit,
    createLead,
    createNewUser,
    updateUser,
    createCategory,
    getUserActive,
    getUserDeactive,
    getEmsSlotBookingByUser,
    getLeadById,
    getTxListByUser,
    getFollowUpListByLeadId,
    getLoginHistoryListByUserId,
    getTrainerSlotBookingByUserId,
    getMassageSlotBookingByUserId,
    getGroupClassSlotBookingByUserId,
    disableLead,
    disableReminder,
    updateReminderStatus,
    disableUser,
    deleteLead,
    deleteCategory,
    verifyEmail,
    loginToThisAccount,
    getAllSport,
    getAllSeries,
    getAllMatch,
    createSport,
    updateUserpassword,
    createSeries,
    createMatch,
    getUserProfile,
    getAllMatchActive,
    updateMatchStatus,
    uploadImage,
    updateMatchMarketId,
    getOdds,
    getMatchBymatchId,
    updateMatchTeamImage,
    AddUserBalance,
    uploadVideo,
    deductUserBalance,
    getUserListIsDisable,
    getLeadList,
    getReminderList,
    getCategoryList,
    getAllCategory,
    getAllUser,
    deleteTicket,
    disableTicket,
    approveTicket,
    getUserList,
    updateLead,
    updateCategory,
    createFollowUp,
    updateCategoryStatus,
    changePassword
};

function updateCategoryStatus(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateCategoryStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateCategoryStatus: data.data
            }
            console.log("i am in service updateCategoryStatus ::", userObj);

            return userObj;
        });
}

function changePassword(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/changePassword`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                UpdatePasswordUser: data.data
            }
            // console.log("I am in service UpdatePasswordUser", userObj);

            return userObj;
        });
}

function updateCategory(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateCategory`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateCategory: data.data
            }
            console.log("i am in service updateCategory ::", userObj);

            return userObj;
        });
}

function updateLead(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateLead`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateLead: data.data
            }
            console.log("i am in service updateLead ::", userObj);

            return userObj;
        });
}

function createFollowUp(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createFollowUp`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                createFollowUp: data.data
            }
            console.log("i am in service createFollowUp ::", userObj);

            return userObj;
        });
}

function getUserList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            console.log("i am in service getUserList ::", data.data);

            let userObj = {
                getUserList: data.data
            }
            console.log("i am in service getUserList ::", userObj);

            return userObj;
        });
}

function getAllCategory() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getAllCategory`, requestOptions)
        .then(handleResponse)
        .then(data => {
            console.log("i am in service getAllCategory ::", data.data);

            let userObj = {
                getAllCategory: data.data
            }
            console.log("i am in service getAllCategory ::", userObj);

            return userObj;
        });
}

function getAllUser() {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getAllUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            console.log("i am in service getAllUser ::", data.data);

            let userObj = {
                getAllUser: data.data
            }
            console.log("i am in service getAllUser ::", userObj);

            return userObj;
        });
}

function getCategoryList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getCategoryList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            console.log("i am in service getCategoryList ::", data.data);

            let userObj = {
                getCategoryList: data.data
            }
            console.log("i am in service getCategoryList ::", userObj);

            return userObj;
        });
}

function getLeadList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getLeadList `, requestOptions)
        .then(handleResponse)
        .then(async (data) => {

            // console.log('data_________', data.data);
            // Receive the 'encrypted' data from the API response

            // console.log('env("API_HOST")______', env("secretKey"));
            // const secretKey = 'supersecretkey12345678901234567890123456789012';
            // console.log("@@@@@@@@", process.env.secretKey)
            // const decryptedBytes = CryptoJS.AES.decrypt(data.data, secretKey);
            // const decryptedPlaintext = decryptedBytes.toString(CryptoJS.enc.Utf8);
            // const decryptedData = JSON.parse(decryptedPlaintext)
            let userObj = {
                getLeadList: data.data
            }
            // console.log("i am in service getLeadList  ::", userObj);

            return userObj;
        });
}

function getReminderList(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getReminderList `, requestOptions)
        .then(handleResponse)
        .then(async (data) => {
            let userObj = {
                getReminderList: data.data
            }
            return userObj;
        });
}
function deleteTicket(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deleteTicket `, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                deleteTicket: data.data
            }
            console.log("i am in service deleteTicket  ::", userObj);

            return userObj;
        });
}
function disableTicket(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateTicketStatus `, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                disableTicket: data.data
            }
            console.log("i am in service disableTicket  ::", userObj);

            return userObj;
        });
}
function approveTicket(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/approveTicket`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                approveTicket: data.data
            }
            console.log("i am in service approveTicket ::", userObj);

            return userObj;
        });
}


function updateMatchMarketId(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateMatchMarketId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateMatchMarketIdItems: data.data
            }
            console.log("i am in service updateMatchMarketId ::", userObj);

            return userObj;
        });
}


function updateUserPassword(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateUserPassword`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateUserpasswordItem: data.data
            }
            console.log("i am in service updateUserPassword ::", userObj);

            return userObj;
        });
}



function deductUserBalance(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deductUserBalance`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                deductUserBalance: data.data
            }
            console.log("i am in service deductUserBalance ::", userObj);

            return userObj;
        });
}
function AddUserBalance(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/AddUserBalance`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                AddUserBalance: data.data
            }
            console.log("i am in service AddUserBalance ::", userObj);

            return userObj;
        });
}
function createMatch(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createMatch`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                createSerie: data.data
            }
            console.log("i am in service createMatchcreateMatchcreateMatchcreateMatch ::", userObj);

            return userObj;
        });
}

function uploadVideo(filedata) {

    let header = new Headers({
        "Authorization": authHeader().Authorization
    });
    var data = new FormData();
    data.append('image', filedata);

    const requestOptions = {
        method: "POST",
        headers: header,
        body: data
    }
    return fetch(CONST.BACKEND_URL + `/uploadImage`, requestOptions)
        .then(handleResponse)
        .then(res => {
            let userObj = {
                videoDetails: res.data
            }
            console.log("servive_uploadImage", userObj);
            return userObj;
        });
}

function uploadImage(filedata) {

    let header = new Headers({
        "Authorization": authHeader().Authorization
    });
    var data = new FormData();
    data.append('image', filedata);

    const requestOptions = {
        method: "POST",
        headers: header,
        body: data
    }
    return fetch(CONST.BACKEND_URL + `/uploadImage`, requestOptions)
        .then(handleResponse)
        .then(res => {
            let userObj = {
                filesDetails: res.data
            }
            console.log("servive_uploadImage", userObj);
            return userObj;
        });
}

function createSeries(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createSeries`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                createSerie: data.data
            }
            console.log("i am in service createSeriescreateSeriescreateSeriescreateSeries ::", userObj);

            return userObj;
        });
}

function updateMatchStatus(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateMatchStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateMatchStatus: data.data
            }
            // console.log("i am in service updateMatchStatus ::", userObj);

            return userObj;
        });
}
function createSport(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createSport`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                createMatch: data.data
            }
            // console.log("i am in service createSportcreateSportcreateSportcreateSport ::", userObj);

            return userObj;
        });
}
function updateUserpassword(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/changePasswordUserIdWise`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateUserpassword: data.data
            }
            // console.log("i am in service updateUserpasswordupdateUserpasswordupdateUserpasswordupdateUserpassword ::", userObj);

            return userObj;
        });
}

function getAllMatchActive(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "GET",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getAllMatchActive`, requestOptions)
        // return fetch(CONST.BACKEND_URL + `/getAllMatchActive?sportId=4&seriesId=11365612`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                allMatchActive: data.data
            }
            console.log("i am in service getAllMatchActive:::::::::::", userObj);

            return userObj;
        });
}
function getAllMatch(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "GET",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getAllMatch?sportId=${data.sportId}&seriesId=${data.seriesId}`, requestOptions)
        // return fetch(CONST.BACKEND_URL + `/getAllMatch?sportId=4&seriesId=11365612`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                allMatch: data.data
            }
            console.log("i am in service getAllMatchgetAllMatchgetAllMatchgetAllMatch:::::::::::", userObj);

            return userObj;
        });
}
function updateMatchTeamImage(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateMatchTeamImage`, requestOptions)
        // return fetch(CONST.BACKEND_URL + `/updateMatchTeamImage?matchId=4&seriesId=11365612`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateMatchTeamImage: data
            }
            console.log("i am in service updateMatchTeamImage:::::::::::123", userObj);

            return userObj;
        });
}

function getUserProfile(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserProfile`, requestOptions)
        // return fetch(CONST.BACKEND_URL + `/getAllMarket?matchId=4&seriesId=11365612`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getUserProfile: data.data
            }
            console.log("i am in service getAllMarket:::::::::::123", userObj);

            return userObj;
        });
}

function getMatchBymatchId(data) {
    // console.log("getMatchBymatchIdSERVICE1", data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getMatchBymatchId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getMatchBymatchId: data
            }
            // console.log("i am in service getMatchBymatchId ::", userObj);

            return userObj;
        });
}
function getOdds(marketId) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "GET",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getOdds?marketId=${marketId}`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getallOdds: data
            }
            // console.log("i am in service getOdds ::", userObj);

            return userObj;
        });
}
function getAllSeries(sportId) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "GET",
        headers: header,
        // body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getAllSeries?sportId=${sportId}`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                allSeries: data.data
            }
            // console.log("i am in service getAllSeriesgetAllSeriesgetAllSeries ::", userObj);

            return userObj;
        });
}

function getAllSport(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "GET",
        headers: header,
    }
    return fetch(CONST.BACKEND_URL + `/getActiveSport`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                AllSport: data.data
            }
            // console.log("i am in service allSportallSportallSportallSport ::", userObj);

            return userObj;
        });
}


function logout() {
    // localStorage.removeItem('adminuser');
    // // window.location.href = "#/login";
    // history.push(`#/login`);
    // window.location.reload();


}
function login(data) {

    let header = new Headers({
        'Content-Type': 'application/json',
        // "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }

    console.log("requestOptions@@@@@@@@@@@@@@@@@@@@@@@@@@", requestOptions);

    return fetch(CONST.BACKEND_URL + `/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            let userObj = {
                userinfo: user.data
            }
            if (user.data) {
                localStorage.setItem('adminuser', JSON.stringify(user.data));
            }

            return userObj;
        });
}

function verifyEmail(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/validateOtpAdmin`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                verifyEmail: data.data
            }
            // console.log("i am in service''...>> verifyEmail ::", userObj);

            return userObj;
        });
}
function deleteLead(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deleteLead`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                deleteLead: data.data
            }
            // console.log("i am in service''...>> deleteLead ::", userObj);

            return userObj;
        });
}

function deleteCategory(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/deleteCategory`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                deleteCategory: data.data
            }
            // console.log("i am in service''...>> deleteLead ::", userObj);

            return userObj;
        });
}
function disableLead(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateFollowUpStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                disableLead: data.data
            }
            return userObj;
        });
}

function disableReminder(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateFollowUpStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                disableLead: data.data
            }
            return userObj;
        });
}

function updateReminderStatus(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateReminderStatus`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                updateReminderStatus: data.data
            }
            // console.log("i am in service''...>> updateReminderStatus ::", userObj);

            return userObj;
        });
}

function disableUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/disableUser`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                disableLead: data.data
            }
            // console.log("i am in service''...>> disableLead ::", userObj);

            return userObj;
        });
}
function getUserActive(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserList`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getUserActive: data.data
            }
            // console.log("i am in service getUserActive ::", userObj);

            return userObj;
        });
}
function getTxListByUser(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getTxListByUser`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getTxListByUser: data.data
            }
            console.log("i am in service getTxListByUser111111111 ::", userObj);

            return userObj;
        });
}
function getLeadById(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getLeadById`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getLeadById: data.data
            }
            console.log("i am in service getUserParkingList111111111 ::", userObj);

            return userObj;
        });
}
function getFollowUpListByLeadId(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getFollowUpListByLeadId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getFollowUpListByLeadId: data.data
            }
            console.log("i am in service getOrderListByUser111111111 ::", userObj);

            return userObj;
        });
}
function getLoginHistoryListByUserId(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getLoginHistoryListByUserId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getLoginHistoryListByUserId: data.data
            }
            console.log("i am in service getLoginHistoryListByUserId111111111 ::", userObj);

            return userObj;
        });
}
function getEmsSlotBookingByUser(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getEmsSlotBookingByUser`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getEmsSlotBookingByUser: data.data
            }
            console.log("i am in service getEmsSlotBookingByUser111111111 ::", userObj);

            return userObj;
        });
}
function getMassageSlotBookingByUserId(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getMassageSlotBookingByUserId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getMassageSlotBookingByUserId: data.data
            }
            console.log("i am in service getMassageSlotBookingByUserId111111111 ::", userObj);

            return userObj;
        });
}
function getGroupClassSlotBookingByUserId(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getGroupClassSlotBookingByUserId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getGroupClassSlotBookingByUserId: data.data
            }
            console.log("i am in service getGroupClassSlotBookingByUserId111111111 ::", userObj);

            return userObj;
        });
}
function getTrainerSlotBookingByUserId(data) {
    console.log('data___data____data:::????', data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getTrainerSlotBookingByUserId`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getTrainerSlotBookingByUserId: data.data
            }
            console.log("i am in service getTrainerSlotBookingByUserId111111111 ::", userObj);

            return userObj;
        });
}
function getUserDeactive(data) {
    console.log("data m kya aa rha h::service:::", data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserList`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getUserDeactive: data.data
            }
            // console.log("i am in service getUserDeactive ::", userObj);

            return userObj;
        });
}

function createCategory(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createCategory`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                createCategory: data.data
            }
            // console.log("I am in service createCategory", userObj);

            return userObj;
        });
}

function createLead(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createLead`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                createLead: data.data
            }
            // console.log("I am in service createLead", userObj);

            return userObj;
        });
}

function createNewUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/createNewUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                createNewUser: data.data
            }
            // console.log("I am in service createNewUser", userObj);

            return userObj;
        });
}

function updateUser(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/updateUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                updateUser: data.data
            }
            // console.log("I am in service updateUser", userObj);

            return userObj;
        });
}

function updateUserPasswordSubmit(data) {
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/UpdatePasswordUser`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let userObj = {
                UpdatePasswordUser: data.data
            }
            // console.log("I am in service UpdatePasswordUser", userObj);

            return userObj;
        });
}

function loginToThisAccount(data) {
    // console.log("data m kya aa rha h::service:::", data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/loginToUserAccount`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                loginToThisAccount: data.data
            }
            // console.log("i am in service loginToThisAccount {{{{{{{}}}}}}}::", userObj);

            return userObj;
        });
}

function getProfile(data) {
    // console.log("data m kya aa rha h::service:::", data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getProfile`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getProfile: data.data
            }
            // console.log("i am in service loginToThisAccount {{{{{{{}}}}}}}::", userObj);

            return userObj;
        });
}
function getUserListIsDisable(data) {
    // console.log("data m kya aa rha h::service:::", data);
    let header = new Headers({
        'Content-Type': 'application/json',
        "Authorization": authHeader().Authorization
    });
    const requestOptions = {
        method: "POST",
        headers: header,
        body: JSON.stringify(data)
    }
    return fetch(CONST.BACKEND_URL + `/getUserListIsDisable`, requestOptions)
        .then(handleResponse)
        .then(data => {

            let userObj = {
                getUserListIsDisable: data.data
            }
            // console.log("i am in service loginToThisAccount {{{{{{{}}}}}}}::", userObj);

            return userObj;
        });
}

// function getRestaurant(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/useroverView`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 restaurantDetails: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }
// function getAllNotification(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/getNotificationList`, requestOptions)
//         .then(handleResponse)
//         .then(data => {

//             let userObj = {
//                 listOfNotification: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }
// function updateNotificationStatus(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updateNotificationStatus`, requestOptions)
//         .then(handleResponse)
//         .then(data => {

//             let userObj = {
//                 listOfNotification: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }
// function createNewUser(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/createNewUser`, requestOptions)
//         .then(handleResponse)
//         .then(data => {

//             let userObj = {
//                 createNewUser: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }
// function deleteLead(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/deleteLead`, requestOptions)
//         .then(handleResponse)
//         .then(data => {

//             let userObj = {
//                 deleteLead: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }

// function addMenu(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/addMenu`, requestOptions)
//         .then(handleResponse)
//         .then(data => {

//             let userObj = {
//                 addMenu: data.data
//             }
//             console.log();

//             return userObj;
//         });
// }

// function addItem(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/addItem`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 addItem: data.data
//             }
//             return userObj;
//         });
// }

// function updatePasswordUser(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updatePasswordUser`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 addItem: data.data
//             }
//             return userObj;
//         });
// }
// function sendFrom(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/sendFrom`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 addItem: data.data
//             }
//             return userObj;
//         });
// }

// function uploadImage(filedata) {

//     let header = new Headers({
//         "Authorization": authHeader().Authorization
//     });
//     var data = new FormData();
//     data.append('image', filedata);

//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: data
//     }
//     return fetch(CONST.BACKEND_URL + `/uploadFile`, requestOptions)
//         .then(handleResponse)
//         .then(res => {
//             let userObj = {
//                 filesDetails: res.data
//             }
//             return userObj;
//         });
// }

// function onChangeImageFile(filedata,id) {

//     let header = new Headers({
//         "Authorization": authHeader().Authorization
//     });
//     var data = new FormData();
//     data.append('image', filedata);

//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: data
//     }
//     return fetch(CONST.BACKEND_URL + `/uploadFile`, requestOptions)
//         .then(handleResponse)
//         .then(res => {
//             let userObj={
//                 "id": id,
//                 "isAdd": true,
//                 "imageName": res.data.uploadedImageName
//             }
//             console.log("userObj  ",userObj);

//             return this.addOrRemoveImageInRestaurant(userObj)

//         });
// }
// function onChangeImageFileLogo(filedata,id) {
//     let header = new Headers({
//         "Authorization": authHeader().Authorization
//     });
//     var data = new FormData();
//     data.append('image', filedata);
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: data
//     }
//     return fetch(CONST.BACKEND_URL + `/uploadFile`, requestOptions)
//         .then(handleResponse)
//         .then(res => {
//             let userObj={
//                 "restaurantId": id,
//                 "imageName": res.data.uploadedImageName
//             }
//             console.log("userObj  ",userObj);
//             return this.updateRestaurantLogo(userObj)
//         });
// }
// function addOrRemoveImageInRestaurant(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/addOrRemoveImageInRestaurant`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 addImageRestaurant: data.data
//             }
//             return userObj;
//         });
// }
// function updateRestaurantLogo(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updateRestaurantLogo`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 addImageRestaurant: data.data
//             }
//             return userObj;
//         });
// }
// function deleteItem(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/deleteItem`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 delItem: data.data
//             }
//             return userObj;
//         });
// }
// function disableItem(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/disableItem`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 disableItem: data.data
//             }
//             return userObj;
//         });
// }

// function deleteRestaurant(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/verifyEmail`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 deleteRestaurant: data.data
//             }
//             return userObj;
//     });
// }

// function disableRestaurant(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/disableLead`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 disableRestaurant: data.data
//             }
//             return userObj;
//     });
// }
// function disableCategory(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/disableMenu`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 disableCategory: data.data
//             }
//             return userObj;
//     });
// }
// function deleteCategory(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/deleteMenu`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 deleteCategory: data.data
//             }
//             return userObj;
//     });
// }

// function updateRestaurant(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updateRestaurant`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 updateRestaurant: data.data
//             }
//             return userObj;
//     });
// }

// function updateCategory(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updateMenu`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 updateCategory: data.data
//             }
//             return userObj;
//     });
// }


// function updateItem(data) {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header,
//         body: JSON.stringify(data)
//     }
//     return fetch(CONST.BACKEND_URL + `/updateItem`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 updateItem: data.data
//             }
//             return userObj;
//     });
// }

// function statics() {
//     let header = new Headers({
//         'Content-Type': 'application/json',
//         "Authorization": authHeader().Authorization
//     });
//     const requestOptions = {
//         method: "POST",
//         headers: header
//     }
//     return fetch(CONST.BACKEND_URL + `/adminoverView`, requestOptions)
//         .then(handleResponse)
//         .then(data => {
//             let userObj = {
//                 statics: data.data
//             }
//             return userObj;
//         });
// }

function handleResponse(response) {
    // console.log("response22222   ", response);

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }
            console.log("datadatadata ", response);

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        //console.log("datadatadatadatadata   ", data.error);
        if (data.error) {
            console.log("datadatadatadatadata   ", data);
            if (data.code === 3) {
                logout();
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}